var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timestamp"},[(_vm.block)?[_c('span',[_vm._v(_vm._s(_vm.date))]),_c('span',[_vm._v(_vm._s(_vm.time))])]:_c('span',[_vm._v(" "+_vm._s(_vm.date)+" "+_vm._s(_vm.time)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }